import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-1 relative z-0 flex overflow-visible my-6 h-[95%]" }
const _hoisted_2 = { class: "flex-1 relative z-0 overflow-visible focus:outline-none xl:order-last" }
const _hoisted_3 = { class: "absolute inset-0 py-2" }
const _hoisted_4 = { class: "h-full bg-white shadow-modal rounded-lg flex flex-col" }
const _hoisted_5 = { class: "flex items-center justify-end w-full my-6 px-4 sm:px-6 lg:max-w-7xl lg:px-8" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "hidden lg:flex t-22m text-wrh-blue-dark flex-grow" }, /*#__PURE__*/_toDisplayString('Sorted by Most Recent'), -1)
const _hoisted_7 = { class: "flex w-full lg:w-auto items-center justify-between lg:justify-end space-x-3" }
const _hoisted_8 = { class: "t-14r text-wrh-gray-dark capitalize" }
const _hoisted_9 = { class: "group space-y-8" }
const _hoisted_10 = { class: "grid grid-cols-9 lg:grid-rows-2 gap-8" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "w-full aspect-w-100 aspect-h-100 bg-gray-200 overflow-hidden xl:aspect-w-100 xl:aspect-h-75" }
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "mt-6 t-16r text-wrh-gray-darken text-left" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Enim nec adipiscing vitae tellus cursus tincidunt tempus. Venenatis fermentum urna risus, nisl viverra amet, viverra in. At tincidunt lacus, risus cras sed vestibulum pellentesque in. ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "mt-6 t-16r text-wrh-gray-darken text-left" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit.dolor sit amet, consectetur adipiscing elit ", -1)
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "w-full aspect-w-100 aspect-h-100 bg-gray-200 xl:aspect-w-100 xl:aspect-h-75" }
const _hoisted_18 = ["src"]

import { ref } from 'vue';
// import { format } from 'date-fns';
import {
  TabGroup, TabList, Tab, TabPanels, TabPanel,
} from '@headlessui/vue';
// import {
//   Carousel, Slide, Pagination, Navigation,
// } from 'vue3-carousel';
// import Markdown from 'vue3-markdown-it';
import 'vue3-carousel/dist/carousel.css';
import Lightbox from '../../components/Lightbox.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  homeId: {
    type: String,
    required: false,
    default: '456789384765h',
  },
},
  setup(__props) {



const mediaUrls = ref(['https://images.unsplash.com/photo-1593085512500-5d55148d6f0d?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Y2FydG9vbnxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&w=1000&q=80']);
const lightboxIndex = ref(0);
const mode = ref(0);
const modes = ['List View', 'grid View'];
// const posts = [];
const title = 'Rough Mechanics';
const postBy = 'Uploaded by Linda Thompson';
const postDate = 'Date Taken: May 15, 2020';

// TODO: total number of posts and media assets should be overall, read from the home, so it's decoupled from pagination

const lightboxOpen = ref(false);

const openLightbox = (mediaUrl: string) => {
  const slideIndex = mediaUrls.value.findIndex((m) => m === mediaUrl);
  lightboxIndex.value = slideIndex;
  lightboxOpen.value = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(TabGroup), {
            "default-index": mode.value,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (mode.value = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(mode.value === 0 ? '18 Posts Total' : '10 Photos Total'), 1),
                  _createVNode(_unref(TabList), { class: "flex p-1 space-x-1 bg-wrh-blue-background rounded-md" }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(modes, (mode) => {
                        return _createVNode(_unref(Tab), {
                          key: mode,
                          as: "template"
                        }, {
                          default: _withCtx(({ selected }) => [
                            _createElementVNode("button", {
                              class: _normalizeClass([
                        'w-full t-14r py-2 px-3 rounded-md capitalize whitespace-nowrap',
                        'focus:outline-none focus:ring-2 ring-offset-2 ring-offset-wrh-blue-extralight ring-wrh-gray-dark ring-opacity-20',
                        selected
                          ? 'bg-white shadow-modal text-black'
                          : 'text-wrh-gray-medium hover:bg-white/[0.12] hover:text-wrh-gray-dark',
                      ])
                            }, _toDisplayString(mode), 3)
                          ]),
                          _: 2
                        }, 1024)
                      }), 64))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createVNode(_unref(TabPanels), { class: "w-full pb-12 px-4 sm:px-6 lg:max-w-7xl lg:px-8 overflow-y-auto scrollbar scrollbar-thin scrollbar-thumb-wrh-gray-dark scrollbar-track-wrh-gray-extralight" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TabPanel), { class: "grid grid-cols-1 gap-y-8" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("figure", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mediaUrls.value, (mediaUrl) => {
                            return (_openBlock(), _createElementBlock("a", {
                              href: "javascript:void(0);",
                              key: mediaUrl,
                              class: "col-span-9 lg:col-span-4 row-span-1 lg:row-span-2 w-full block group focus:outline-none",
                              onClick: ($event: any) => (openLightbox(mediaUrl))
                            }, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("img", {
                                  src: mediaUrl,
                                  alt: "",
                                  class: "object-center object-cover group-hover:opacity-85 transition-opacity duration-300 ease-in-out"
                                }, null, 8, _hoisted_13)
                              ])
                            ], 8, _hoisted_11))
                          }), 128)),
                          _createElementVNode("figcaption", { class: "col-span-9 lg:col-span-5 row-span-1 lg:row-span-2 flex flex-col items-start justify-start" }, [
                            _createElementVNode("h3", { class: "t-32m text-black" }, _toDisplayString(title)),
                            _createElementVNode("div", { class: "mt-6 t-14r text-wrh-blue-light flex flex-col items-start justify-start" }, [
                              _createElementVNode("span", null, _toDisplayString(postBy)),
                              _createElementVNode("span", null, _toDisplayString(postDate))
                            ]),
                            _hoisted_14,
                            _hoisted_15
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(TabPanel), { class: "grid grid-cols-1 gap-y-8 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 2xl:grid-cols-4 2xl:gap-x-8" }, {
                    default: _withCtx(() => [
                      _createElementVNode("figure", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mediaUrls.value, (mediaUrl) => {
                          return (_openBlock(), _createElementBlock("a", {
                            href: "javascript:void(0);",
                            key: mediaUrl,
                            class: "group",
                            onClick: ($event: any) => (openLightbox(mediaUrl))
                          }, [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("img", {
                                src: mediaUrl,
                                alt: "",
                                class: "object-center object-cover group-hover:opacity-85 transition-opacity duration-300 ease-in-out"
                              }, null, 8, _hoisted_18)
                            ])
                          ], 8, _hoisted_16))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["default-index"]),
          _createVNode(Lightbox, {
            open: lightboxOpen.value,
            "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => (lightboxOpen.value = $event)),
            "current-slide": lightboxIndex.value,
            "onUpdate:current-slide": _cache[2] || (_cache[2] = ($event: any) => (lightboxIndex.value = $event)),
            "media-urls": mediaUrls.value
          }, null, 8, ["open", "current-slide", "media-urls"])
        ])
      ])
    ])
  ]))
}
}

})